<template>
    <div>
        <b-form-group
                :label-for="`id_${field._id}`"
                :class="{
                'required-field': !!field.isRequired,
            }"
        >
            <div class="row d-flex">
                <div class="col-md-10">
                    <h5>{{field.label}}</h5>
                </div>
                <!-- <div v-if="onBoardIndividualKeys.includes(field.key)" class="col-md-4 text-right">
                    
                        <b-form-checkbox
                            :id="`id_${field._id}`"
                            v-model="onBoardIndividual"
                            :value="true"
                            :name="field._id"
                            :disabled="disableOnBoardIndividual || loading"
                            :data-vv-name="field.label"
                            @input="setField"

                        >
                        <span style="margin-top: 5px;">
                            Screen and Onboard {{field.label}}
                        </span>
                        </b-form-checkbox>

                </div> -->
                <div class="col-md-2">
                    <span class="addMoreIcon" title="Add More" @click="addMoreFields">+</span>
                </div>
            </div>

            <div class="form-border"></div>
            <!--<div class="row">-->
                <!--<div class="col-md-12">-->
                    <!--<span class="addMoreIcon" title="Add More" @click="addMoreFields">+</span>-->
                <!--</div>-->
            <!--</div>-->
                <div v-for="(additionalField, index) in additionalFields" :key="`${index}_${additionalField.uniqueId}`" class="row shadow mb-4 position-relative">
                    <div v-for="(fieldOption, optionIndex) in field.multiOptions" :key="optionIndex"
                         :class="{
                            'col-md-12': Math.ceil(field.multiOptions.length) == 1,
                            'col-md-6': Math.ceil(field.multiOptions.length) == 2,
                            'col-md-4': Math.ceil(field.multiOptions.length) >= 3,
                            // 'col-md-3': Math.ceil(field.multiOptions.length) >= 4,

                        }"
                    >
                        <b-form-group :label="fieldOption.label" :label-for="`id_${field._id}`"
                                      :class="{
                'required-field': !!field.isRequired || allowRequiredValidation(fieldOption, index) || handleConditionalRequired(fieldOption, index),
            }">
                            <component
                                :is="typeAliases[fieldOption.type]"
                                v-bind="getFieldProps(fieldOption)"

                                v-model="additionalField[fieldOption.key]"
                                v-validate="getValidationRules(fieldOption,index)"
                                :disabled="loading || isDisabled || manualDisable(additionalField, fieldOption)"
                                :data-vv-name="getFieldLabel(fieldOption, index)"
                                :class="{
                                    'all-gray':    ['name', 'dob', 'countryOfResidenceId', 'nationalityId', 'dateOfAppointment','shares'].includes(fieldOption.key) 
                                                    && (
                                                        (!! additionalField.isCompanyAPI && additionalField[fieldOption.key]) || (additionalField.tagged && fieldOption.key!='dateOfAppointment' && fieldOption.key!='shares')
                                                    ),
                                    'is-invalid': errors.has(getFieldLabel(fieldOption, index)),
                                }"
                                @input="['base-file-input'].includes(fieldOption.type) ? null : updateValue(field.key, fieldOption.key, index, $event)"
                                @data="updateValue(field.key, fieldOption.key, index, $event)"
                                :customValue="additionalField[fieldOption.key]"
                                :field="{...fieldOption, 'isDynamicInput':true}"
                            ></component>
                        </b-form-group>
                    </div>


                    <div class="col-md-4 " v-if="copyToOptions.length && !additionalField.copiedFrom">
                        <b-dropdown dropright class="mb-3 copyDropDown">
                            <template #button-content>
                                Copy to
                            </template>
                            <!-- <b-dropdown-item v-for="(option, copyIndex) in copyToOptions" :key="copyIndex" @click="sendCopyData(additionalField, option.value, index)"> -->
                            <b-dropdown-item v-for="(option, copyIndex) in copyToOptions" :key="copyIndex" @click="sendCopyData(getDataFromStore(field.key, index), option, index)">
                                {{ option.text }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                    
                    <!-- Cross/Remove Btn  -->
                    <span
                            v-if="additionalFields.length > 1"
                            class="removed-row-class"
                            @click.prevent="deleteRow(index,field.key)"
                    ><i class="icon-delete"></i
                    ></span>
                    <!-- Cross/Remove Btn End  -->
                </div>

        </b-form-group>
    </div>
</template>




<script>
    import { mapGetters } from 'vuex'
    import TextField from '@/components/registration/TextField.vue'
    import TextArea from '@/components/registration/TextArea.vue'
    // import DatePicker from '@/components/registration/DatePicker.vue'
    import DatePicker from 'vue2-datepicker'
    import List from '@/components/registration/List.vue'
    import Dropdown from '@/components/registration/Dropdown.vue'
    import Radio from '@/components/registration/Radio.vue'
    import Checkbox from '@/components/registration/Checkbox.vue'
    import BaseFileInput from '@/components/BaseFileInput.vue'
    
    import request from '@/utils/request'

    export default {
        /*
        |--------------------------------------------------------------------------
        | Component > inject
        |--------------------------------------------------------------------------
        */
        inject: {
            $validator: '$validator',
        }, // End of Component > inject

        /*
        |--------------------------------------------------------------------------
        | Component > components
        |--------------------------------------------------------------------------
        */
        components: {
            TextField,
            TextArea,
            DatePicker,
            List,
            Dropdown,
            Radio,
            Checkbox,
            BaseFileInput,
        }, // End of Component > components

        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        props: {
            field: {
                type: Object,
                required: true,
            },
            dataSegmentId: {
                type: String,
                required: true,
            }
        }, // End of Component > props

        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
        data() {
            return {
                value: '',
                unUsedVariable: '',
                isDisabled: false,
                country:process.env.VUE_APP_COUNTRY,
                allExceptSpecialCharacters: /^[^!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/,
                dynamicInputValues: {},
                additionalFields: [],
                typeAliases: {
                    'text-field': "b-form-input",
                    'dropdown': "b-form-select",
                    'list': "b-form-select",
                    'date-picker': "date-picker",
                    'checkbox-single': "b-form-checkbox",
                    'base-file-input':'base-file-input',
                },
                dropdownOptions: {}, 
                onBoardIndividualKeys: ['authorisedPersons', 'companyShareholders', 'companyDirectors', 'companyExecutiveManagement', 'companyUltimateBeneficialOwner'],
                onBoardIndividual: false,
                disableOnBoardIndividual: false,
                copyableEntities: {
                    'account-info': [
                     {
                        text: 'Company Shareholders',
                        value: 'companyShareholders',
                    },
                    {
                        text: 'Authorised Persons',
                        value: 'authorisedPersons',
                    },
                    {
                        text: 'Company Directors',
                        value: 'companyDirectors',
                    },
                    {
                        text: 'Company Executive Management',
                        value: 'companyExecutiveManagement',
                    },
                    {
                        text: 'Company Ultimate Beneficial Owner',
                        value: 'companyUltimateBeneficialOwner',
                    },
                ]
                }
              
            }
        }, // End of Component > data

        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        //    contactInfo.city
        async created() {
            await this.getAssociatedRecords()

            // for checkbox next to heading
            // if (this.field.customerDetails && this.field.customerDetails.dynamicSettings ){
            //    const checked = this.field.customerDetails.dynamicSettings.onboard && this.field.customerDetails.dynamicSettings.onboard[this.field.key];
            //     this.disableOnBoardIndividual = checked // in case of edit, don't allow to uncheck if checked
            //     this.setField(checked)
            // }
            

            let valueFound=false
            let isEdit = false
            let existingVal = ''
            let existingFields=this.$store.getters.form.dynamicInputValues
            if((existingFields && existingFields[this.field.key]))
            {
                existingVal=this.$store.getters.form.dynamicInputValues[this.field.key]
                if(existingVal.length>0)
                {
                    valueFound=true
                }
            }
            else if(this.field.customerDetails && this.field.customerDetails.dynamicInputValues && this.field.customerDetails.dynamicInputValues[this.field.key])
            {
                 existingVal=this.field.customerDetails.dynamicInputValues[this.field.key]
                if(existingVal.length>0)
                {
                    valueFound=true
                    isEdit=true
                }
            }



            if(valueFound)
            {
                for(let i=0;i<existingVal.length;i++)
                {
                    const additionalField = {};
                    let customerId = existingVal[i] ? existingVal[i].customerId : null;
                    let uniqueId = existingVal[i] ? existingVal[i].uniqueId : this.generateUniqueId();
                    let copiedFrom = existingVal[i] ? existingVal[i].copiedFrom : null;
                    let copiedFromKey = existingVal[i] ? existingVal[i].copiedFromKey : null;
                    let tagged = existingVal[i] ? existingVal[i].tagged : false;
                    let idCardType = existingVal[i] ? existingVal[i].idCardType : false;
                    if(customerId) {
                        this.updateValue(this.field.key,'customerId', i, customerId);
                    }
                    if(uniqueId) {
                        this.updateValue(this.field.key,'uniqueId', i, uniqueId);
                    }
                    if(copiedFrom) {
                        this.updateValue(this.field.key,'copiedFrom', i, copiedFrom);
                    }
                    if(copiedFromKey) {
                        this.updateValue(this.field.key,'copiedFromKey', i, copiedFromKey);
                    }
                    if(tagged) {
                        this.updateValue(this.field.key,'tagged', i, tagged);
                    }
                    if(idCardType) {
                        this.updateValue(this.field.key,'idCardType', i, idCardType);
                    }
                    this.field.multiOptions.forEach((fieldOption) => {
                        let val= ""

                        if(existingVal[i][fieldOption.key])
                        {
                            val=existingVal[i][fieldOption.key]

                        }
                        additionalField[fieldOption.key] = val;

                        // if(isEdit)
                        if(val)
                        {
                            this.updateValue(this.field.key,fieldOption.key,i,val)
                        }

                    });
                    additionalField['isCompanyAPI'] = existingVal[i] ? existingVal[i].isCompanyAPI : false ;
                    additionalField['customerId'] = customerId;
                    additionalField['uniqueId'] = uniqueId;
                    additionalField['copiedFrom'] = copiedFrom;
                    additionalField['copiedFromKey'] = copiedFromKey;
                    additionalField['tagged'] = tagged;
                    additionalField['idCardType'] = idCardType;

                    this.additionalFields.push({...additionalField});
              }
            }
            else
            {
                const additionalField = {};
                this.field.multiOptions.forEach((fieldOption) => {
                    additionalField[fieldOption.key] = '';
                });
                this.additionalFields.push(additionalField);
            }

        }, // End of Component > methods
        computed: {
            ...mapGetters(['loading', 'copyData', 'dynamicInputValuesModified', 'getField']),
            copyToOptions(){
                let options = this.copyableEntities[this.field.section];
                if(!options) return []

                options = options.filter(el=> el.value != this.field.key);
                // if(['companyShareholders', 'companyUBOs', 'authorisedPersons', 'companyCEOs'].includes(this.field.key) ) {
                //     options = options.filter(el=> !['companyDirectors', 'companyMLROs'].includes(el.value) );
                // }
                return options;
            }
        }, // End of Component > methods

        /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
        mounted() {
            this.handleCustomRequired();
        }, // End of Component > computed
        watch: {
            copyData(value){ // receiveCopyData
                if(value.key != this.field.key || !value.data) return;
                
                const {data} = value
                const initialLength = this.dynamicInputValues[this.field.key] ? this.dynamicInputValues[this.field.key].length : 0;
                let indexToFill = 0;
                if( initialLength && initialLength > 0 ) {
                    const lastRowFilled = this.areFieldsFilled( this.dynamicInputValues[this.field.key][initialLength - 1] )
                    indexToFill = lastRowFilled ?  initialLength : initialLength - 1;
                }
                for (let objKey in data) {
                    this.updateValue(this.field.key, objKey, indexToFill, data[objKey],true);
                }
                this.additionalFields = [...this.dynamicInputValues[this.field.key]];

            },
            dataSegmentId(value) {
                if (value) {
                    this.getAssociatedRecords()
                }
            },
            async dynamicInputValuesModified(value) {
                let data = this.$store.getters.getField('dynamicInputValues')[this.field.key]
                if(data) {
                    this.additionalFields = [...data];
                }
            },
        }, // End of Component > computed

        /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
        methods: {
            allowRequiredValidation(fieldOption, index){
                if (fieldOption && fieldOption.isRequired && this.additionalFields[index] ) {
                    let newObj = {...this.additionalFields[index]};
                    delete newObj.onboard
                    delete newObj.uniqueId
                    return !this.$isObjectEmpty(newObj);
                }
                return false;
            },
            handleConditionalRequired(fieldOption, index){
                if(fieldOption.dependsOn && fieldOption.dependsOn.key && this.getField(`dynamicInputValues[${this.field.key}].${index}`)) {
                    let val = this.getField(`dynamicInputValues[${this.field.key}].${index}.${fieldOption.dependsOn.key}`)
                    if(!val) return false
                    let newObj = {...this.additionalFields[index]};
                    delete newObj.onboard
                    delete newObj.uniqueId
                    let result= (fieldOption.dependsOn.ifValueIn.includes(val) || !fieldOption.dependsOn.ifValueNotIn.includes(val)) && !this.$isObjectEmpty(newObj);
                    return result
                }
                return false;
            },
            getFieldLabel(fieldOption, index){
                return `${this.field.label} ${index+1} ${fieldOption.label}`
            },
            getDataFromStore(key, index){
                return this.getField(`dynamicInputValues.${key}[${index}]`)
            },
            sendCopyData(fieldOption, {value:key,text:copyToLabel}, index) {
                let filled = this.areFieldsFilled(fieldOption);
                if(!filled) return;

                let copyObj = {};
                for (let key in fieldOption) {
                    if(['shares', 'entityType', 'customerId', 'uniqueId'].includes(key) ) continue;

                    copyObj[key] = fieldOption[key];
                }
                if(!fieldOption['uniqueId']) {
                    fieldOption['uniqueId'] = this.generateUniqueId();
                    this.updateValue(this.field.key, 'uniqueId', index, fieldOption['uniqueId'])
                }
                copyObj['copiedFrom'] = fieldOption['uniqueId'];
                copyObj['copiedFromKey'] = this.field.key;
                if(
                    Array.isArray(this.$store.getters.getField(`dynamicInputValues.${key}`)) &&
                    this.$store.getters.getField(`dynamicInputValues.${key}`).find(el=> el.copiedFrom == fieldOption['uniqueId'])
                ) {
                    this.$store.commit('setError',`Already exist in ${copyToLabel}`);
                    return
                }
                this.$store.commit("setValue", {
                    key: 'copyData',
                    value: { key, data: copyObj}
                });
                this.$store.commit('setSuccess',`successfully copied to ${copyToLabel}`);

            },
            areFieldsFilled(fieldOption){
                let filled = false;
                for (let key in fieldOption) {
                    if(['shares', 'entityType', 'customerId', 'onboard', 'uniqueId'].includes(key) ) continue;

                    if(!!fieldOption[key]) return true;
                }
                return filled;
            },
            getValidationRules(fieldOption,index){
                let conditionalRequired = this.handleConditionalRequired(fieldOption, index)
                let rules = {
                    required: this.allowRequiredValidation(fieldOption,index) || conditionalRequired,
                    email: !!fieldOption.isEmail,
                    // numeric: !!fieldOption.isNumeric,
                    decimal: !!fieldOption.isNumeric,
                    // regex: allExceptSpecialCharacters ,
                    // max: field.maxLength,
                    // min: field.minLength,
                }
                if(fieldOption.key == 'shares'){
                    rules['max_value'] = 100;    
                }
                return rules;
            },
            manualDisable(additionalField, fieldOption){
                if(this.onBoardIndividualKeys.includes(this.field.key)) {
                    return (!!additionalField['copiedFrom'] && !['shares','entityType'].includes(fieldOption['key']) ) || (!!additionalField['customerId'] && fieldOption.key == 'onboard' ) || (additionalField['tagged'] && fieldOption.key!='dateOfAppointment' && fieldOption.key!='shares') ;
                }
                return false;
            },
            getFieldProps(fieldOption){
                let data = {}
                if(fieldOption.type == 'date-picker') {
                    data ={
                        "format": "DD-MM-YYYY",
                        "lang": "en",
                        "end-at":  ['birth', 'incorporation', 'dob', 'dateOfTermination'].some((el) =>  fieldOption.key.includes(el)) ? new Date() : '',
                        "start-at":  ['expirydate', 'expiry','idExpiry','passportExpiry'].some((el) =>  fieldOption.key.includes(el)) ? new Date() :new Date('01/01/1900'),
                        "default-value": new Date(),
                    }
                } else if(['dropdown', 'list'].includes(fieldOption.type) ){
                    data = {
                        options: [{text: fieldOption.placeholder, value: '' }, ... fieldOption.options || []],
                    }
                } else if( fieldOption.type == 'checkbox-single' ){
                    data = {
                        value: true,
                        "unchecked-value": false,
                    }
                } else if( fieldOption.type == 'base-file-input' ){
                    data = {
                        placeholder: fieldOption.placeholder,
                        fileType: 'customers'
                    }
                } 
                else { //text
                    data = {
                        placeholder: fieldOption.placeholder,
                        type : "text",
                    }
                }
                return data;
            },
            addMoreFields() {
                const additionalField = {};
                additionalField.uniqueId = this.generateUniqueId()
                this.field.multiOptions.forEach((fieldOption) => {
                    additionalField[fieldOption.key] = '';
                });
                this.additionalFields.push(additionalField);

            },
            updateValue(parentKey, key, index, event, createNewIfNull = false) {
                // console.log('parentKey',parentKey,'key',key,'event',event,'index',index)

                if(!this.additionalFields[index]) {
                    if(createNewIfNull) {
                        this.additionalFields[index] = {
                            uniqueId: this.generateUniqueId()
                        }
                    } else {
                        console.log("skipping", this.additionalFields[index])
                        return;
                    }
                }
                if(parentKey=='companyShareholders' && key=='name')
                {
                    if(event=='')
                    {
                        this.updateValue(parentKey,'onboard',index,false)
                        this.additionalFields[index].onboard=false
                    }
                    else {
                        this.updateValue(parentKey,'onboard',index,true)
                        this.additionalFields[index].onboard=true
                    }
                    // console.log('-------',this.additionalFields['0'].onboard)
                }

                if (!this.dynamicInputValues[parentKey]) {
                    this.dynamicInputValues[parentKey] = this.$store.getters.getField(`dynamicInputValues.${parentKey}`) || [];
                }
                // Update the array at the specified index with the new object
                const fieldValue = { [key]: event };

                if (this.dynamicInputValues[parentKey].length <= index) {
                    this.dynamicInputValues[parentKey].push(fieldValue);
                } else
                    {
                    this.dynamicInputValues[parentKey][index] = {
                        ...this.dynamicInputValues[parentKey][index],
                        ...fieldValue,
                    };
                }
                // for association like nationalityId => nationality 
                let childField = this.field.multiOptions.find(el => el.key == key);
                if(childField && childField.isAssociation ) {
                    let textValue = childField.options.find(el=> el.value == this.dynamicInputValues[parentKey][index][key] )
                    if(textValue) {
                        textValue = textValue.text;
                        this.dynamicInputValues[parentKey][index] = { ...this.dynamicInputValues[parentKey][index], [key.slice(0,-2)]: textValue }; //slice: nationalityId = nationality
                    }
                    else if(!textValue){
                        this.dynamicInputValues[parentKey][index] = { ...this.dynamicInputValues[parentKey][index], [key.slice(0,-2)]: '' };
                    }
                }
                // association end

                let value = this.dynamicInputValues[parentKey][index]
                this.$store.commit('setDynamicInputValue', { parentKey,key, index,value });
            },
            getDynamicFieldName(parentKey, childKey) {
                let customInfo = this.$store.getters.getField(`dynamicInputValues.${parentKey}.${childKey}`)
                return customInfo;
            },
            setField(newValue) {
                this.onBoardIndividual = newValue
                const fieldKey = 'dynamicSettings.onboard.'+this.field.key;
                if (this.field.isLocked) {
                    this.$store.commit('updateField', {
                        key: fieldKey,
                        value: newValue,
                    })
                } else {
                    this.$store.commit('updateField', {
                        key: `customInfo.${this.field._id}`,
                        value: {
                            title: this.field.label,
                            type: this.field.type,
                            value: newValue,
                        },
                    })
                }
            },
            deleteRow(index,parentKey) {
                let copiedArray = JSON.parse(JSON.stringify(this.additionalFields));
                copiedArray.splice(index, 1)
                let removeFieldObj = this.getDataFromStore(parentKey,index)
                let newDynamicInputValues =  this.$store.getters.getField('dynamicInputValues')
                if(removeFieldObj && removeFieldObj.uniqueId){
                    let uniqueChild = removeFieldObj
                    let isUniqueKeyPlaced = false
                    let newUniqueChildKey = ''
                    let uniqueId = this.generateUniqueId()
                for(let individualKey of this.onBoardIndividualKeys) {
                    if(!newDynamicInputValues[individualKey] ) continue;
                    newDynamicInputValues[individualKey] = newDynamicInputValues[individualKey].filter((el) =>{
                        if(    ( el.uniqueId && !el.copiedFrom && el.uniqueId.toString() != uniqueChild.uniqueId.toString() ) // filter unique records except the unique one we want
                            || ( el.copiedFrom && uniqueChild.uniqueId && el.copiedFrom.toString() != uniqueChild.uniqueId.toString() )  // filters copiedFrom except copiedFrom targeted unique record
                        ){
                            return el
                        }else if(el.copiedFrom && el.copiedFromKey  && el.copiedFrom.toString()  == uniqueChild.uniqueId.toString()){
                           if(!isUniqueKeyPlaced){
                                delete el.copiedFrom 
                                delete el.copiedFromKey
                                el.customerId = uniqueChild.customerId
                                el.uniqueId = uniqueId
                                el.onboard = true
                                isUniqueKeyPlaced = true
                                newUniqueChildKey = individualKey
                                return el
                           }else{
                                el.copiedFrom  =  uniqueId
                                el.copiedFromKey = newUniqueChildKey
                                return el
                           }  
                        }
                    });
                }
               }
                this.additionalFields = [...copiedArray];
                this.dynamicInputValues[parentKey] = [...copiedArray]
                if(removeFieldObj && removeFieldObj.uniqueId){
                    this.$store.commit('updateField', {
                        key: `dynamicInputValues`,
                        value: {...newDynamicInputValues},
                    })
                }else{
                    this.$store.commit('updateField', {
                        key: `dynamicInputValues.${parentKey}`,
                        value: [...copiedArray],
                    })
                }
                
            },

            async getAssociatedRecords() {
                
                try {
                    let optionPromises =  this.field.multiOptions.map(async (fieldOption) =>{
                        // fetch the list of associated configurations
                        if(['dropdown', 'list'].includes(fieldOption.type) && fieldOption.isAssociation)
                        {
                            let { data } = await request({
                                url: `/configurations/${fieldOption.association}`,
                                params: {
                                    dataSegmentId: this.dataSegmentId,
                                    status: 'active',
                                    perPage: 1000,
                                    ref: 'dropdown',
                                },
                            })
    
                            fieldOption.options = data.data.map(el =>( {...el, text: el.title, value: el._id}) );
                        }
                        
                        // if (fieldOption.type === 'isd-code') {
                        //     fieldOption.options = this.options.filter((item) => {
                        //         item.isdCodeTitle = `${item.title} (${item.isdCode})`
                        //         return item
                        //     })
                        // }

                        return fieldOption;
                    } )
                    this.field.multiOptions = await Promise.all(optionPromises)



                } catch (error) {
                    console.log(error)
                }
            },
            generateUniqueId() {
                const timestamp = new Date().getTime(); 
                const random = Math.floor(Math.random() * 1000000); 
                const uniqueId = `${timestamp}-${random}`;
                
                return uniqueId;
            }

        }, // End of Component > mounted
    }
</script>
<style>
    .divider
    {
        border-bottom: 1px solid grey;
        width: 100%;
        margin-bottom: 2%;
    }
    .addMoreIcon
    {
        background: var(--primary-color);
        color: white;
        padding-right: 7px;
        padding-left: 7px;
        cursor: pointer;
        float: right;
    }
    .copyDropDown{
        overflow:visible !important;
    }
</style>
